import { useTranslation } from 'react-i18next';

// components
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import StaffListComponent from '../../../components/Persons/StaffList/Staff.List.Component';

export const StaffListPage = () => {
  //useTranslation()
  const [t] = useTranslation();

  /* Sin solapas: quedó sólo el listado de miembros.
     Los tipos de identificación se administran en "Configuraciones adicionales"
     (/more-settings, spec 011). Los tipos de relación se sacaron por ahora; su
     componente sigue en su lugar (RelationshipTypes.List.Component). */
  return (
    <>
      <PageHeader
        title={t('staffListPage.title', { defaultValue: 'Staff' })}
        subtitle={t('staffListPage.subtitle', {
          defaultValue: 'Administración de las personas que integran el staff'
        })}
      />
      <div className="Content">
        <div className="Section">
          <StaffListComponent />
        </div>
      </div>
    </>
  );
};

export default StaffListPage;
